import { Model } from '../../interfaces/pages/projects'

export type Type = Model

export const initial: Type = {
  filter: {
    clients: [],
    statuses: [],
    query: '',
    favorite: false,
    pageNo: null,
  },
  tablePagination: {
    pageNo: 0,
    resultsPerPage: 10,
    ordering: {
      columnName: 'deadline',
      direction: 'desc',
    },
  },
  loading: false,
  saving: false,
  result: {
    projects: [],
    pagination: {
      page: 0,
      totalRows: 0,
      next: null,
      previous: null,
    },
  },
  error: null,
}
